import { Modal } from "react-bootstrap";
import i18n from "i18next";
import cropxLogo from "../../img/logo/CropX_logo.svg";

import { TS } from "../util";
import React from "react";

export const AccountModal = (showModal?: boolean, onClose?: () => void) => {
  return (
    <Modal
      show={showModal}
      onHide={onClose}
      aria-labelledby="contained-modal-title"
      className="mod_bb_subscribe"
      animation={false}
      backdrop="static"
      backdropClassName="bb-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {i18n.t("Create a free account or login to use this functionality")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="float-right">
          <img alt="CropX" className="d-none d-sm-block" width="200" src={cropxLogo} />
          <img alt="CropX" className="d-inline-block d-sm-none" width="150" src={cropxLogo} />
        </div>
        <h4>{i18n.t("With a free account you can use many extra functionalities:")}</h4>
        <ul>
          <TS t="AccountFeatures" />
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <a className="btn btn-success float-left" href="/authorize?create=1">
          {i18n.t("Create an account")}
        </a>
        <a className="btn btn-info" href="/authorize">
          {i18n.t("Login")}
        </a>
      </Modal.Footer>
    </Modal>
  );
};
